import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { styled, Typography } from '@mui/material';
import { getColor, getPadding, getBorderRadius } from '@volt_developers/foundations';

function Pill(_a) {
    var { children, sx, variant } = _a, rest = __rest(_a, ["children", "sx", "variant"]);
    return (jsx(Wrapper, Object.assign({}, rest, { sx: Object.assign(Object.assign({}, VARIANT_STYLES[variant]), sx), children: jsx(StyledTypography, { variant: "buttonSmall", children: children }) })));
}
const VARIANT_STYLES = {
    custom: {},
    default: {
        backgroundColor: getColor("blue50"),
        color: getColor("blue500"),
        borderColor: getColor("blue100"),
    },
    success: {
        backgroundColor: getColor("green50"),
        color: getColor("green600"),
        borderColor: getColor("green100"),
    },
    error: {
        backgroundColor: getColor("red50"),
        color: getColor("red500"),
        borderColor: getColor("red100"),
    },
    disabled: {
        backgroundColor: getColor("grey50"),
        color: getColor("grey500"),
        borderColor: getColor("grey100"),
    },
    progress: {
        backgroundColor: getColor("orange50"),
        color: getColor("orange600"),
        borderColor: getColor("orange100"),
    },
};
const Wrapper = styled("div")({
    display: "inline-block",
    padding: getPadding(1, 3),
    borderRadius: getBorderRadius(4),
    borderWidth: 1,
    borderStyle: "solid",
});
const StyledTypography = styled(Typography)({
    letterSpacing: 0,
    display: "block",
});

export { Pill };
//# sourceMappingURL=Pill.js.map
